import { axiosAPI } from '@/axios';

const getAllFilesInServer = (page) => {
  let url = 'files';
  if (page) {
    url += `?page=${page}`;
  }
  return axiosAPI.get(url);
};

const loadAttachmentById = (attachmentId) => {
  return axiosAPI.get(`/attachments/${attachmentId}`);
};

const createAttachment = (attachment) => {
  return axiosAPI.post('/attachments', attachment);
};

const deleteAttachmentById = (attachmentId) => {
  return axiosAPI.delete(`/attachments/${attachmentId}`);
};

const updateAttachmentById = (attachmentId, attachment) => {
  return axiosAPI.put(`/attachments/${attachmentId}`, attachment);
};

const deleteFileById = (fileId) => {
  return axiosAPI.delete(`/files/${fileId}`);
};

const deleteFilesInsideAttachment = (attachmentId, fileIds) => {
  return axiosAPI.post(`/attachments/${attachmentId}/files/batch-delete`, fileIds);
};

const addFilesToAttachment = (attachmentId, files) => {
  return axiosAPI.post(`/attachments/${attachmentId}/files/batch-create`, files);
};

const renameFileById = (attachmentId, file) => {
  const fileId = file.id;
  const payload = { name: file.name };
  return axiosAPI.put(`/attachments/${attachmentId}/files/${fileId}`, payload);
};

const searchFilesByFileName = (fileName) => {
  return axiosAPI.get(`/files?q=${fileName}`);
};

export {
  getAllFilesInServer,
  loadAttachmentById,
  createAttachment,
  deleteAttachmentById,
  updateAttachmentById,
  deleteFileById,
  deleteFilesInsideAttachment,
  searchFilesByFileName,
  addFilesToAttachment,
  renameFileById,
};
